import paths from 'routing/routes/_paths';

import Reports from 'views/reports';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.reports,
    component: Reports,
    documentTitle: 'Reports'
  }
];

export default routes;
